import ReadinessIssues from "../PeriodRelease/ReadinessIssues";
import {createReadinessIssuesListItem} from "../../utils/util";
import {sortArraysWithNullsLast, sortAscendingWithNullsFirst} from "../../utils/sorting";
import RetailerTotalCell from "../PeriodRelease/Readiness/RetailerTotalCell";
import StoreTotalCell from "../PeriodRelease/Readiness/StoreTotalCell";
import OutliersCell from "../PeriodRelease/Readiness/OutliersCell";
import UnmappedStoresCell from "../PeriodRelease/Readiness/UnmappedStoresCell";
import React from "react";
import RetailerIdAndName from "../Components/RetailerIdAndName";
import {getRetailerName} from "../../utils/localCache/retailerMapCache";

export function getReadinessColumns(alertIsLoading, outlet) {
    return [
        {
            header: 'Retailer',
            accessorKey: 'retailer.retailerId',
            cell: ({row})=> <RetailerIdAndName retailerId={row.original.retailer.retailerId}/>,
            size: 100,
            className: 'non-numeric-field',
            filterFn: (row, columnIds, filterValue) => !filterValue || Boolean(`${row.original.retailer.retailerId} ${getRetailerName(row.original.retailer.retailerId)?.toLowerCase()}`.includes(filterValue.toLowerCase()))
        },
        {
            header: 'Issues',
            id: 'issues',
            accessorKey: 'issues',
            enableColumnFilter: false,
            className: 'non-numeric-field',
            maxSize: 100,
            cell: ({getValue}) => <ReadinessIssues issues={getValue()}
                                                collapsedContent={getValue() && `${getValue().length} issues`}
                                                createListItem={createReadinessIssuesListItem}/>,
            sortingFn: (rowA, rowB) => {
                const filterRow = row => row.original.issues;
                return sortArraysWithNullsLast(filterRow(rowA), filterRow(rowB));
            }
        },
        {
            header: 'Retailer Total',
            id: 'retailer-total',
            accessorKey: 'issues',
            enableColumnFilter: false,
            className: 'non-numeric-field',
            maxSize: 60,
            cell: ({row}) => <RetailerTotalCell data={row.original}/>,
            sortingFn: (rowA, rowB) => {
                const filterRow = row => row.original.issues?.filter(x => x.issueType === 'missingData');
                return sortArraysWithNullsLast(filterRow(rowA), filterRow(rowB));
            }
        },
        {
            header: 'Store Total',
            id: 'store-total',
            enableColumnFilter: false,
            accessorKey: 'weeksWithSales',
            className: 'non-numeric-field',
            maxSize: 60,
            cell: ({row}) => <StoreTotalCell data={row.original}/>,
            sortingFn: (rowA, rowB) => {
                const x = rowA.original.weeksWithSales.weeksWithData / rowA.original.weeksWithSales.totalExpectedWeeks
                const y = rowB.original.weeksWithSales.weeksWithData / rowB.original.weeksWithSales.totalExpectedWeeks
                return sortAscendingWithNullsFirst(x, y)
            }
        },
        {
            header: 'Outliers',
            id: 'outliers',
            enableColumnFilter: false,
            minWidth: 200,
            className: 'non-numeric-field',
            cell: ({row}) => <OutliersCell data={row.original}/>,
        },
        {
            header: 'Unmapped Stores',
            id: 'unmapped-stores',
            accessorFn: (original) => (original.issues ? original.issues.find(x => x.issueType === 'unmappedStores') : {count: null}) || {count: null},
            enableColumnFilter: false,
            className: 'non-numeric-field',
            maxSize: 30,
            cell: ({row}) => <UnmappedStoresCell data={row.original}/>,
            sortingFn: (rowA, rowB) => {
                const filterRow = row => row.original.issues?.filter(x => x.issueType === 'unmappedStores').length;
                return sortAscendingWithNullsFirst(filterRow(rowA), filterRow(rowB));
            }
        },
        {
            header: 'Outlets',
            id: 'outlets',
            accessorKey: 'allOutlets',
            enableColumnFilter: false,
            className: 'non-numeric-field',
            maxSize: 80,
            cell: ({getValue}) => getValue().filter(x => x !== outlet),
        }
    ];
}
